import { render, staticRenderFns } from "./CRUDListTotal.vue?vue&type=template&id=5163987e&"
import script from "./CRUDListTotal.vue?vue&type=script&lang=js&"
export * from "./CRUDListTotal.vue?vue&type=script&lang=js&"
import style0 from "./CRUDListTotal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports